import Button from "components/buttons/Buttons";
import { planProgramsCards } from "helpers/planProgramsCards";

function HomePrograms(props) {
  const unRegularPlanProgram = planProgramsCards.filter((item) => {
    return item.type === 2;
  });

  const regularPlanProgram = planProgramsCards.filter((item) => {
    return item.type === 1;
  });

  return (
    <>
      <div className="home__programs-wrapper">
        <div className="home__programs-title">
          <h1>Planprogramet Verore</h1>
          {/* <h2>Plan Programet Verore</h2> */}
        </div>
        <div className="home__programs-container">
          {unRegularPlanProgram.map((i, index) => {
            return (
              <div
                key={index}
                className={`home__programs-card ${i.theme}-theme`}
              >
                <div className="home__programs-img">
                  <img loading="lazy" src={i.img} alt="PlanProgram" />
                </div>
                <div className="home__programs-content-card">
                  <div className="home__programs-content-titles">
                    <div className="home__programs-subtitle">
                      <h2>{i.age}</h2>
                    </div>
                    <span>
                      <h2 className="summer__program-title">{i.title}</h2>
                    </span>
                  </div>
                  <Button
                    className={["home__programs-btn"]}
                    RedirectLink={i.redirect}
                    ButtonTitle="Më Shumë"
                    size={"sm"}
                    variant={"purple"}
                    ariaLabel={"Më Shumë"}
                  />
                </div>
                <div className="home__programs-bgImg">
                  <img src={i.bg} alt="Programs Card" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="home__programs-wrapper">
        <div className="home__programs-title">
          <h1>Planprogramet</h1>
          {/* <h2>Plan Programet të thjeshta</h2> */}
        </div>
        <div className="home__programs-container">
          {regularPlanProgram.map((i, index) => {
            return (
              <div
                key={index}
                className={`home__programs-card ${i.theme}-theme`}
              >
                <div className="home__programs-img">
                  <img loading="lazy" src={i.img} alt="PlanProgram" />
                </div>
                <div className="home__programs-content-card">
                  <div className="home__programs-content-titles">
                    <div className="home__programs-subtitle">
                      <h2>{i.age}</h2>
                    </div>
                    <span>
                      <h1>{i.title}</h1>
                      <h2>{i.subtitle}</h2>
                    </span>
                  </div>
                  <Button
                    className={["home__programs-btn"]}
                    RedirectLink={i.redirect}
                    ButtonTitle="Më Shumë"
                    size={"sm"}
                    variant={"purple"}
                    ariaLabel={"Më Shumë"}
                  />
                </div>
                <div className="home__programs-bgImg">
                  <img src={i.bg} alt="Programs Card" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default HomePrograms;
